import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'sidebarCollapsed';

/**
 * Shared sidebar collapse state with localStorage persistence.
 * Use a unique `storageKey` when a sidebar needs independent state
 * (e.g. workspace vs admin). Falls back to a single global key.
 */
export function useSidebarCollapse(storageKey = STORAGE_KEY) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, String(collapsed));
    } catch {
      // ignore storage errors
    }
  }, [collapsed, storageKey]);

  const toggle = useCallback(() => setCollapsed(prev => !prev), []);

  return [collapsed, toggle, setCollapsed] as const;
}
